// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import routes from './router'
import { checkBrowser } from './assets/js/common.js'
import Param from './assets/js/Param.js'
Vue.use(VueRouter);
Vue.use(VueResource);

const router=new VueRouter({
    mode:'history',
    routes
});

Vue.config.productionTip = false

Vue.prototype.version = 'v3.0';

//test
// Vue.prototype.portURL = "http://recharge-test.api.china-m2m.com";
// Vue.prototype.personalURL = "http://uc-test.api.china-m2m.com";
// Vue.prototype.successURL = "http://recharge.test.china-m2m.com/home";
// Vue.prototype.redirect_url = "http://recharge.test.china-m2m.com";
// Vue.prototype.redirect_url = "http://192.168.0.154:8081";

//product
Vue.prototype.portURL = "http://recharge.api.china-m2m.com";
Vue.prototype.personalURL = "http://uc.api.china-m2m.com";
Vue.prototype.successURL = "http://recharge.china-m2m.com/home";
Vue.prototype.redirect_url = "http://recharge.china-m2m.com";
// Vue.prototype.redirect_url = "http://localhost:8081";


Vue.prototype.getUrlParam = function(name){
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
	var r = window.location.search.substr(1).match(reg);  //匹配目标参数
	if (r != null) return unescape(r[2]); return null; //返回参数值
}

Vue.prototype.isAlipayOrWechat = function(){
	var userAgent = navigator.userAgent.toLowerCase();
    if(userAgent.match(/Alipay/i) == "alipay") {
//      this.path = 'http://zfb.china-m2m.com/weixin/new_auth';
//      this.client_type = 'alipay';
        return 'alipay,http://zfb.china-m2m.com/weixin/new_auth,ALIPAYH5';
    } else if(userAgent.match(/MicroMessenger/i) == "micromessenger") {
//      this.path = 'http://wx.china-m2m.com/weixin/new_auth';
//      this.client_type = 'wechat';
        return 'wechat,http://wx.china-m2m.com/weixin/new_auth,WEIXINH5';
        
    }
}
Vue.prototype.environment = false;
//document.addEventListener('UniAppJSBridgeReady', function() {
//  uni.getEnv(function(res) {
//     Vue.prototype.environment = true;
// 	});
//});

window.appToken=function(msg){
  localStorage.setItem("token", msg);
}

Vue.http.interceptors.push((request, next) => {
	request.headers.set('Authorization', localStorage.getItem("token") )
//	request.headers.set('Authorization', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Inlpdmk2YWp1bXVtaSJ9.eyJpc3MiOiJodHRwOlwvXC91Yy10ZXN0LmFwaS5jaGluYS1tMm0uY29tIiwiYXVkIjoiaHR0cDpcL1wvdWMtdGVzdC5hcGkuY2hpbmEtbTJtLmNvbSIsImp0aSI6Inlpdmk2YWp1bXVtaSIsImlhdCI6MTU0NjQxMTA2NiwiZXhwIjoxNTQ2NDExNjY2LCJpZCI6IjEzIiwidXVpZCI6IjIwMTgxMjI5OTk5NjgyOTEiLCJuaWNrbmFtZSI6InVuZGVmaW5lZCIsImVtYWlsIjoiIiwibW9iaWxlIjoiMTgyNzE5MDA2MzQiLCJnZW5kZXIiOiIwIiwiYWdlIjoiMCIsImF2YXRhciI6InVuZGVmaW5lZCIsImluX2JsYWNrbGlzdCI6IjAiLCJkaXNhYmxlZCI6IjAiLCJjcmVhdGVkIjoiMTU0NjA2NTM0NiIsInVwZGF0ZWQiOiIxNTQ2MDczNDczIn0.aWWtqPJ4-NC9hdmZELyRXX4OPiYVkjqz9Cmi146JXMaou1sYanTBm8JwefBx78m5XWkB0f4hJj1MLsPgSoS1CbJag1Z4as5hBPIUezWnthG4Dpu7vfif_MAwbl5iCAtao4Yl5cw9Zl75DuLowWJdFKXeJcVt-NLqYgpyrp9-xJo' )
	next(response => {
		
	    if(response.data.status === 401){
				let UA = navigator.userAgent.toLowerCase();
				if(/(ylkids_android)/.test(UA)) {
					// let str3 = window.jsInterface.GetToken();
					// localStorage.setItem("token", str3);
					window.jsInterface.tokenTnvalid();
				} else if(/(ios1.1.0)/.test(UA)) {
					window.webkit.messageHandlers.getIosToken.postMessage({method:"tokenTnvalid"});
				}else{
					localStorage.removeItem("token");
					location.reload();
				}

		}else{
			return response
		}
	})
})

const wx = require('weixin-js-sdk')
Vue.prototype.wx = wx
const scanUrlArray = ['/youKu/forward']
const scanApi = '/test/v1/rc-activity/to-share-jssdk?'
router.afterEach((to, from) => {
  if (checkBrowser() === 'wechat') {
    if (to.query.activity_id) localStorage.setItem('activity_id', to.query.activity_id)
    if (to.params.activity_id) localStorage.setItem('activity_id', to.params.activity_id)
    if (scanUrlArray.includes(to.path)) {
			Vue.http.get(scanApi + Param.init({ page_url: `${Vue.prototype.redirect_url}${to.path}` }).re())
        .then(res => {
					console.log(res)
          if (res.data.error === 0) {
            wx.config({
              debug: false,
              appId: res.data.data.appId,
              signature: res.data.data.signature,
              timestamp: res.data.data.timestamp,
              nonceStr: res.data.data.nonceStr,
              jsApiList: ["updateAppMessageShareData", "onMenuShareAppMessage"]
            })
          }
        })
    }
  }
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
    router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js